(() => {
  // Switches from ISO8601 format to the one specified
  const dateInFormat = (dateString, format) => {
    const splitDate = dateString.split("-");
    const year = splitDate[0];
    const month = splitDate[1];
    const day = splitDate[2];
    let newDate;

    // If the date is incomplete we return an empty string
    if (!day || !month || !year) {
      return "";
    }

    if (format === "%m/%d/%Y") {
      newDate = `${month}/${day}/${year}`;
    } else if (format === "%d/%m/%Y") {
      newDate = `${day}/${month}/${year}`;
    }

    return newDate;
  };

  document
    .querySelectorAll('input[type="date"][data-date-with-hidden-input="true"]')
    .forEach((input, _i) => {
      const inputName = input.getAttribute("name");
      const hiddenInput = document.querySelector(
        `input[type="hidden"][name="${inputName}"]`,
      );
      const changeEvent = new Event("change");
      input.parentElement.append(hiddenInput);

      input.addEventListener("change", (event) => {
        const dateFormat = event.target.getAttribute("data-string-format");
        const dateString = event.target.value;

        hiddenInput.value = dateInFormat(dateString, dateFormat);
        hiddenInput.dispatchEvent(changeEvent);
      });
    });
})();
